export function PermissionPicker({ all, value, onChange, idPrefix }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={`${idPrefix}-permissions`}>
      {all.map((p) => {
        const on = value.includes(p.key);
        return (
          <button key={p.key} type="button" onClick={() => toggle(p.key)} data-testid={`${idPrefix}-perm-${p.key}`}
            className={`rounded-full border px-2.5 py-0.5 text-[11px] transition-colors ${on ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" : "bg-secondary/40 text-muted-foreground border-border hover:text-foreground"}`}>
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
